import { ChatApiService } from './api/ChatService';

export const getSMTPSettings = async (payload, userToken) => {
    try {
        const queryParams = new URLSearchParams()

        payload?.page && queryParams.append('page', payload.page)
        payload?.perPage && queryParams.append('per_page', payload.perPage)
        payload?.search && queryParams.append('search', payload.search)

        const queryString = queryParams.toString()
        const url = queryString ? `/smtp-settings?${queryString}` : '/smtp-settings'

        const response = await ChatApiService.get(url, {
            headers: {
                'Authorization': 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao buscar configurações SMTP', error);
        throw error;
    }
}

export const updateSMTPSettings = async (payload, userToken) => {
    try {
        const response = await ChatApiService.put(`/smtp-settings/${payload.id}`, payload, {
            headers: {
                'Authorization': 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao atualizar configurações SMTP', error);
        throw error;
    }
}

export const createSMTPSettings = async (payload, userToken) => {
    try {
        const response = await ChatApiService.post('/smtp-settings', payload, {
            headers: {
                'Authorization': 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao criar configurações SMTP', error);
        throw error;
    }
}

export const deleteSMTPSettings = async (smtpSettingsId, userToken) => {
    try {
        const response = await ChatApiService.delete(`/smtp-settings/${smtpSettingsId}`, {
            headers: {
                'Authorization': 'Bearer ' + userToken
            }
        });
        
        return response.data;
    } catch (error) {
        console.error('Erro ao deletar configurações SMTP', error);
        throw error;
    }
}
